import styles from './Icons.module.scss';
import { type HTMLAttributes, memo } from 'react';
import classNames from 'classnames';

export type Props = {
  icon: string;
  spin?: boolean;
  small?: boolean;
  outlined?: boolean;
  className?: string;
} & HTMLAttributes<HTMLElement>;

const MaterialIcon = ({ icon, spin, outlined, small, className, ...props }: Props) => {
  const cssClasses = classNames(
    'icon',
    (outlined ? 'material-icons-outlined' : 'material-icons'),
    {
      [styles.spin]: spin,
      [styles.small]: small,
    },
    className,
  );

  return <i className={cssClasses} key={spin ? 'true' : 'false'} {...props}>{icon}</i>;
};

export default memo(MaterialIcon);
